<div class="row">
  <div class="w-100">
    <lib-video
      class="base-platform-font"
      [src]="slideData.mediaVideo | videoPresign | async"
      [interactive]="slideData.interactiveVideo"
      type="video/mp4"
      [poster]="slideData.mediaVideo?.coverImage"
      [embedVideo]="slideData.embedVideo"
      [showThumbnailsForEmbed]="true"
      [useCustomThumbnailForEmbed]="true"
      [requiredToWatch]="requiredToWatchVideo"
      [completed]="slideData.isVideoWatched"
      [video]="slideData.mediaVideo"
      [containerHeight]="maxVideoHeight"
      [autoplay]="slideData.mediaVideo?.autoplayLoopMode"
      [loop]="slideData.mediaVideo?.autoplayLoopMode"
      [hideControls]="slideData.mediaVideo?.autoplayLoopMode"
      (started)="emitVideoStarted()"
      (watched)="emitVideoWatched()"
      (toggleFullscreen)="toggleFullscreen()"
      >
    </lib-video>

    @if (slideData.captionText) {
      <figcaption class="image-video-caption">
        <span class="caption">{{slideData.captionText}}</span>
      </figcaption>
    }
  </div>
</div>
